import { useMutation } from '@tanstack/react-query';

import { startMiaPaySession } from '../api/payment.api';

interface StartMiaPaySessionParams {
    orderId: string;
}

export const useStartMiaPaySession = () => {
    return useMutation({
        mutationFn: ({ orderId }: StartMiaPaySessionParams) =>
            startMiaPaySession(orderId),
    });
};
